import { preloadComputerTaskPage } from '#pplx/frontend/apps/ask/spa/ComputerTaskPageRouteShared.js';
import { preloadGammaPageLayout } from '#pplx/frontend/apps/ask/spa/GammaPageLayoutRouteSupport.js';
import { preloadSearchComponent } from '#pplx/frontend/apps/ask/spa/SearchComponentsRouteShared.js';
export async function preloadThreadPage(target) {
    if (target === 'computer') {
        await Promise.all([preloadComputerTaskPage(), preloadGammaPageLayout()]);
        return;
    }
    await preloadSearchComponent();
}
//# sourceMappingURL=pagePreloads.js.map